import React, { useState } from 'react'
import { Card, Row, Col, Container } from 'react-bootstrap'
import projects from './projects.json'
import './Projects.css'

const techTags = {
  'project-1': ['AEM Sites', 'Sling Models', 'OSGi', 'Enterprise Architecture', 'Technical Consulting'],
  'project-2': ['AEM Platform', 'Java/J2EE', 'Dispatcher', 'Job Manager', 'Content Distribution'],
  'project-3': ['AEM DAM', 'Custom Components', 'Workflows', 'OSGi Config', 'Accessibility'],
  'project-4': ['Network Architecture', 'Data Center', 'Infrastructure Support']
}

const Projects = () => {
  return (
    <div className="section-container">
      <Container>
        <h2 className="section-title">Work Experience</h2>
        <Row xs={1} md={2} lg={2} className="g-4">
          {projects.map(project => (
            <Col key={project.id}>
              <Card className="modern-card experience-card h-100">
                <div className="experience-card-top">
                  <div className="experience-img-container">
                    <img
                      className="experience-logo-img"
                      src={process.env.PUBLIC_URL + project.img_url}
                      alt={`${project.name} logo`}
                      loading="lazy"
                      decoding="async"
                      onError={e => {
                        e.currentTarget.onerror = null
                        e.currentTarget.src =
                          process.env.PUBLIC_URL + '/assets/images/logo512.jpeg'
                      }}
                    />
                  </div>
                  <div className="experience-header-info">
                    <Card.Title className="experience-company-name">{project.name}</Card.Title>
                    <span className="experience-badge">Experience</span>
                  </div>
                </div>

                <Card.Body className="d-flex flex-column pt-3">
                  <div className="experience-tags mb-3">
                    {(techTags[project.id] || []).map(tag => (
                      <span key={tag} className="tech-tag">
                        {tag}
                      </span>
                    ))}
                  </div>

                  <Card.Text className="flex-grow-1 experience-description">
                    <ReadMore description={project.description} />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  )
}

const ReadMore = ({ description }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const previewLength = 220

  const toggle = () => {
    setIsExpanded(!isExpanded)
  }

  const isLong = description.length > previewLength

  return (
    <span className="read-more-wrapper">
      <span>
        {isExpanded || !isLong ? description : `${description.slice(0, previewLength)}...`}
      </span>
      {isLong && (
        <button
          type="button"
          onClick={toggle}
          className="read-or-hide-btn"
          aria-expanded={isExpanded}
        >
          {isExpanded ? ' Show less ↑' : ' Read more ↓'}
        </button>
      )}
    </span>
  )
}

export default Projects
